import { render, staticRenderFns } from "./MonthlyPower.vue?vue&type=template&id=163acbf2&scoped=true&"
import script from "./MonthlyPower.vue?vue&type=script&lang=js&"
export * from "./MonthlyPower.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyPower.vue?vue&type=style&index=0&id=163acbf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163acbf2",
  null
  
)

export default component.exports